// extracted by mini-css-extract-plugin
export var deleteModal = "_r8-0";